import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";

export type PickersDayStyleFlags = {
  isActive: boolean;
  isBlocked: boolean;
  isSelected: boolean;
  isHoliday?: boolean;
};

export function getPickersDaySx(theme: Theme, flags: PickersDayStyleFlags) {
  const { isActive, isBlocked, isSelected, isHoliday = false } = flags;
  return {
    ...(isHoliday &&
      !isBlocked &&
      !isActive && {
        backgroundColor: alpha(theme.palette.warning.main, 0.18),
        color: theme.palette.warning.dark,
        border: `1px solid ${alpha(theme.palette.warning.main, 0.4)}`,
        fontWeight: 600,
        "&:hover": {
          backgroundColor: alpha(theme.palette.warning.main, 0.28),
        },
      }),
    ...(isActive &&
      !isBlocked && {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: `${theme.palette.primary.contrastText} !important`,
        border: "0 !important",
        "&::after": {
          display: "none",
        },
        "&:hover": {
          backgroundColor: `${theme.palette.primary.dark} !important`,
        },
      }),
    ...(isSelected &&
      !isActive &&
      !isBlocked && {
        backgroundColor: isHoliday
          ? `${alpha(theme.palette.warning.main, 0.18)} !important`
          : "transparent !important",
        color: isHoliday
          ? `${theme.palette.warning.dark} !important`
          : `${theme.palette.text.primary} !important`,
        borderRadius: "50%",
        position: "relative",
        "&::after": {
          content: '""',
          position: "absolute",
          left: "18%",
          right: "18%",
          bottom: 4,
          height: 2,
          borderRadius: 2,
          backgroundColor: theme.palette.primary.main,
        },
        "&:hover": {
          backgroundColor: isHoliday
            ? `${alpha(theme.palette.warning.main, 0.28)} !important`
            : "transparent !important",
        },
      }),
    ...(isBlocked && {
      opacity: 1,
      fontWeight: 600,
      color: theme.palette.error.dark,
      backgroundColor: alpha(theme.palette.error.main, 0.14),
      border: `1px solid ${alpha(theme.palette.error.main, 0.35)}`,
      WebkitTextFillColor: theme.palette.error.dark,
      "&.Mui-disabled": {
        opacity: 1,
        color: theme.palette.error.dark,
        WebkitTextFillColor: theme.palette.error.dark,
        backgroundColor: alpha(theme.palette.error.main, 0.14),
        border: `1px solid ${alpha(theme.palette.error.main, 0.35)}`,
      },
      "&.Mui-disabled:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.22),
      },
    }),
  };
}

export const dateCalendarRootSx = (theme: Theme) => ({
  width: "100%",
  maxWidth: 320,
  p: 0,
  m: 0,
  height: "auto",
  maxHeight: "none",
  minHeight: 0,
  "& .MuiDateCalendar-root": {
    padding: 0,
    margin: 0,
  },
  "& .MuiPickersCalendarHeader-root": {
    padding: 0,
    margin: 0,
    minHeight: 36,
  },
  "& .MuiPickersArrowSwitcher-root": {
    padding: 0,
  },
  "& .MuiDayCalendar-header": {
    justifyContent: "center",
    padding: 0,
    margin: 0,
  },
  "& .MuiDayCalendar-weekContainer": {
    margin: 0,
    padding: 0,
  },
  "& .MuiDayCalendar-slideTransition": {
    minHeight: "auto",
  },
  "& .MuiPickersSlideTransition-root": {
    minHeight: "auto",
  },
  "& .MuiDateCalendar-viewTransitionContainer": {
    minHeight: 0,
    flex: "0 0 auto",
  },
});
